import * as XLSX from "xlsx-js-style";

export const ExcelUtil = {
    getBorderCell() {
        const cellTable = {
            top: { style: 'thin', color: { rgb: "000000" } },
            bottom: { style: 'thin', color: { rgb: "000000" } },
            left: { style: 'thin', color: { rgb: "000000" } },
            right: { style: 'thin', color: { rgb: "000000" } },
        }
        return cellTable
    },
    setCellBoldWithBorder(ws, rangeTitle) {
        // cell.s = {alignment:{ wrapText: true }}
        for(let R = rangeTitle.s.r; R <= rangeTitle.e.r; ++R) {
            for(let C = rangeTitle.s.c; C <= rangeTitle.e.c; ++C) {
                let cell = ws[XLSX.utils.encode_cell({r:R,c:C})];

                if(!cell){
                    continue;
                }
                cell.s = {
                    alignment: { horizontal: "center", wrapText: true },
                    font: { bold: true, name: "AngsanaUPC", sz: "16"},
                    border: this.getBorderCell()
                }
            }
        }
    },
    setCellTextRightBoldWithBorder(ws, rangeTitle) {
        // cell.s = {alignment:{ wrapText: true }}
        for(let R = rangeTitle.s.r; R <= rangeTitle.e.r; ++R) {
            for(let C = rangeTitle.s.c; C <= rangeTitle.e.c; ++C) {
                let cell = ws[XLSX.utils.encode_cell({r:R,c:C})];

                if(!cell){
                    continue;
                }
                cell.s = {
                    alignment: { horizontal: "right", wrapText: true },
                    font: { bold: true, name: "AngsanaUPC", sz: "16"},
                    border: this.getBorderCell()
                }
            }
        }
    },
    setCellCenterNormalWithBorder(ws, rangeOrder){
        for(let R = rangeOrder.s.r; R <= rangeOrder.e.r; ++R) {
            for(let C = rangeOrder.s.c; C <= rangeOrder.e.c; ++C) {
                let cell = ws[XLSX.utils.encode_cell({r:R,c:C})];

                if(!cell) continue;

                cell.s = {
                    alignment: { horizontal: "center" },
                    font: {name: "AngsanaUPC", sz: "16"},
                    border: this.getBorderCell()
                }
            }
        }
    },

    setCellNumberFormatWIthBorder(ws, rangeNumber) {
        // alignment: { horizontal: "right", wrapText: true },
        let fmt = '#,##0.00';
        for(let R = rangeNumber.s.r; R <= rangeNumber.e.r; ++R) {
            for(let C = rangeNumber.s.c; C <= rangeNumber.e.c; ++C) {
                let cell = ws[XLSX.utils.encode_cell({r:R,c:C})];

                if(!cell) continue;

                cell.s = {
                    border: this.getBorderCell(),
                    font: {name: "AngsanaUPC", sz: "16"},
                }

                if(!cell || cell.t != 'n') continue; // only format numeric cells

                cell.z = fmt;

                cell.s = {
                    border: this.getBorderCell(),
                    font: {name: "AngsanaUPC", sz: "16"},
                }
            }
        }
    },
    setCellNumberFormatRightWithBorder(ws, rangeNumber) {
        //
        let fmt = '#,##0.00';
        for(let R = rangeNumber.s.r; R <= rangeNumber.e.r; ++R) {
            for(let C = rangeNumber.s.c; C <= rangeNumber.e.c; ++C) {
                let cell = ws[XLSX.utils.encode_cell({r:R,c:C})];

                if(!cell) continue;

                cell.s = {
                    alignment: { horizontal: "right", wrapText: true },
                    border: this.getBorderCell(),
                    font: {name: "AngsanaUPC", sz: "16"},
                }

                if(!cell || cell.t != 'n') continue; // only format numeric cells

                cell.z = fmt;

                cell.s = {
                    alignment: { horizontal: "right", wrapText: true },
                    border: this.getBorderCell(),
                    font: {name: "AngsanaUPC", sz: "16"},
                }
            }
        }
    },
    setCellNumberFormatBlueWithBorder(ws, rangeNumber) {
        let fmt = '#,##0.00';
        let fontStyle = { color: { rgb: "164E9B" } }
        for(let R = rangeNumber.s.r; R <= rangeNumber.e.r; ++R) {
            for(let C = rangeNumber.s.c; C <= rangeNumber.e.c; ++C) {
                let cell = ws[XLSX.utils.encode_cell({r:R,c:C})];

                if(!cell) continue;

                cell.s = {
                    border: this.getBorderCell(),
                    font: fontStyle
                }

                if(!cell || cell.t != 'n') continue; // only format numeric cells

                cell.z = fmt;

                cell.s = {
                    border: this.getBorderCell(),
                    font: fontStyle
                }
            }
        }
    },
    toDataURL(url) {
        const promise = new Promise((resolve, reject) => {
            let xhr = new XMLHttpRequest();
            xhr.onload = function () {
                let reader = new FileReader();
                reader.readAsDataURL(xhr.response);
                reader.onloadend = function () {
                    resolve({ base64Url: reader.result });
                };
            };
            xhr.open("GET", url);
            xhr.responseType = "blob";
            xhr.send();
        });

        return promise;
    }
}
